import IconProps, { StyledG } from './IconProps';

function StarIconSmall(props: IconProps) {
	const { color = 'primary' } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG color={color} fillRule="nonzero" transform="translate(-413 -691)">
					<path d="M419.875 697.87542L413 698.50043 418.18875 703.733949 416.75 711 422.978125 707.204003 429.20125 711 427.804688 703.728636 433 698.50043 426.125 697.87542 423 691z" />
				</StyledG>
			</g>
		</svg>
	);
}

export default StarIconSmall;
